const contentEn = {
  "admin.content.AdminAnnouncements.0": "Error loading announcements",
  "admin.content.AdminAnnouncements.1": "Title and content are required",
  "admin.content.AdminAnnouncements.2": "Announcement updated",
  "admin.content.AdminAnnouncements.3": "Announcement created",
  "admin.content.AdminAnnouncements.4": "Announcement deactivated",
  "admin.content.AdminAnnouncements.5": "Announcement activated",
  "admin.content.AdminAnnouncements.6": "Announcement deleted",
  "admin.content.AdminAnnouncements.7": "Member announcements",
  "admin.content.AdminAnnouncements.8": "Banner displayed in the member area",
  "admin.content.AdminAnnouncements.9": "New announcement",
  "admin.content.AdminAnnouncements.10": "Loading...",
  "admin.content.AdminAnnouncements.11": "No announcements yet",
  "admin.content.AdminAnnouncements.12": "Create the first announcement",
  "admin.content.AdminAnnouncements.13": "Active",
  "admin.content.AdminAnnouncements.14": "Created on",
  "admin.content.AdminAnnouncements.15": "Edit announcement",
  "admin.content.AdminAnnouncements.16": "New announcement",
  "admin.content.AdminAnnouncements.17": "Displayed as a banner at the top of the member area. Only one banner can be active at a time.",
  "admin.content.AdminAnnouncements.18": "Title",
  "admin.content.AdminAnnouncements.19": "Content",
  "admin.content.AdminAnnouncements.20": "Plain text. Line breaks are preserved.",
  "admin.content.AdminAnnouncements.21": "Style",
  "admin.content.AdminAnnouncements.22": "Info (blue)",
  "admin.content.AdminAnnouncements.23": "Success (green)",
  "admin.content.AdminAnnouncements.24": "Warning (orange)",
  "admin.content.AdminAnnouncements.25": "Activate immediately",
  "admin.content.AdminAnnouncements.26": "Will deactivate other active announcements.",
  "admin.content.AdminAnnouncements.27": "Cancel",
  "admin.content.AdminAnnouncements.28": "Save",
  "admin.content.AdminAnnouncements.29": "Create",
  "admin.content.AdminAnnouncements.30": "Delete this announcement?",
  "admin.content.AdminAnnouncements.31": "This action cannot be undone.",
  "admin.content.AdminAnnouncements.32": "Cancel",
  "admin.content.AdminAnnouncements.33": "Delete",
  "admin.content.AdminResources.0": "Title and category are required",
  "admin.content.AdminResources.1": "Resource updated",
  "admin.content.AdminResources.2": "Resource created",
  "admin.content.AdminResources.3": "Category name is required",
  "admin.content.AdminResources.4": "Category updated",
  "admin.content.AdminResources.5": "Category created",
  "admin.content.AdminResources.6": "Delete this resource?",
  "admin.content.AdminResources.7": "Resource deleted",
  "admin.content.AdminResources.8": "Delete this category? Associated resources will also be deleted.",
  "admin.content.AdminResources.9": "Category deleted",
  "admin.content.AdminResources.10": "Resource management",
  "admin.content.AdminResources.11": "Resources",
  "admin.content.AdminResources.12": "Categories",
  "admin.content.AdminResources.13": "All categories",
  "admin.content.AdminResources.14": "All categories",
  "admin.content.AdminResources.15": "New resource",
  "admin.content.AdminResources.16": "Edit resource",
  "admin.content.AdminResources.17": "New resource",
  "admin.content.AdminResources.18": "Create or edit a resource for members",
  "admin.content.AdminResources.19": "Title *",
  "admin.content.AdminResources.20": "Category *",
  "admin.content.AdminResources.21": "Choose a category",
  "admin.content.AdminResources.22": "Slug (leave blank to generate automatically)",
  "admin.content.AdminResources.23": "Excerpt (short summary)",
  "admin.content.AdminResources.24": "Content (Markdown) *",
  "admin.content.AdminResources.25": "Published",
  "admin.content.AdminResources.26": "Cancel",
  "admin.content.AdminResources.27": "Update",
  "admin.content.AdminResources.28": "Create",
  "admin.content.AdminResources.29": "No resources",
  "admin.content.AdminResources.30": "Draft",
  "admin.content.AdminResources.33": "View resource",
  "admin.content.AdminResources.34": "New category",
  "admin.content.AdminResources.35": "Edit category",
  "admin.content.AdminResources.36": "New category",
  "admin.content.AdminResources.37": "Name *",
  "admin.content.AdminResources.38": "Slug",
  "admin.content.AdminResources.39": "Icon (lucide-react)",
  "admin.content.AdminResources.40": "file-text, mail, shield...",
  "admin.content.AdminResources.41": "Description",
  "admin.content.AdminResources.42": "Display order",
  "admin.content.AdminResources.43": "Cancel",
  "admin.content.AdminResources.44": "Update",
  "admin.content.AdminResources.45": "Create",
  "admin.content.AdminResources.46": "No categories",
  "admin.content.AdminResources.47": "• Order:",
  "admin.content.AdminSuggestions.0": "Feature",
  "admin.content.AdminSuggestions.1": "Improvement",
  "admin.content.AdminSuggestions.2": "In progress",
  "admin.content.AdminSuggestions.3": "Accepted",
  "admin.content.AdminSuggestions.4": "Implemented",
  "admin.content.AdminSuggestions.5": "Rejected",
  "admin.content.AdminSuggestions.6": "Error loading suggestions",
  "admin.content.AdminSuggestions.8": "New suggestion received",
  "admin.content.AdminSuggestions.9": "Suggestion updated",
  "admin.content.AdminSuggestions.10": "Error updating suggestion",
  "admin.content.AdminSuggestions.11": "Permanently delete this suggestion?",
  "admin.content.AdminSuggestions.12": "Error deleting suggestion",
  "admin.content.AdminSuggestions.13": "Suggestion deleted",
  "admin.content.AdminSuggestions.14": "Member suggestions - Admin",
  "admin.content.AdminSuggestions.15": "Manage suggestions submitted by members",
  "admin.content.AdminSuggestions.16": "Member suggestions",
  "admin.content.AdminSuggestions.17": "Status",
  "admin.content.AdminSuggestions.18": "All",
  "admin.content.AdminSuggestions.19": "Category",
  "admin.content.AdminSuggestions.20": "All",
  "admin.content.AdminSuggestions.21": "No suggestions match the filters.",
  "admin.content.AdminSuggestions.26": "Status",
  "admin.content.AdminSuggestions.27": "Reply to member (visible to them)",
  "admin.content.AdminSuggestions.28": "Your reply will be displayed on the member’s page.",
  "admin.content.AdminSuggestions.30": "Delete",
  "admin.content.AdminSuggestions.31": "Cancel",
  "admin.content.AdminSuggestions.32": "Save",
  "admin.content.AdminPostEditor.0": "The title must contain at least 3 characters",
  "admin.content.AdminPostEditor.1": "The title is too long",
  "admin.content.AdminPostEditor.2": "The slug must contain at least 3 characters",
  "admin.content.AdminPostEditor.3": "The slug is too long",
  "admin.content.AdminPostEditor.4": "The slug may only contain lowercase letters, numbers and hyphens",
  "admin.content.AdminPostEditor.5": "The summary is too long",
  "admin.content.AdminPostEditor.6": "The content must contain at least 10 characters",
  "admin.content.AdminPostEditor.7": "The author’s name must contain at least 2 characters",
  "admin.content.AdminPostEditor.8": "Invalid URL",
  "admin.content.AdminPostEditor.9": "Article not found",
  "admin.content.AdminPostEditor.10": "Invalid publication date",
  "admin.content.AdminPostEditor.11": "This slug already exists",
  "admin.content.AdminPostEditor.12": "Error creating article",
  "admin.content.AdminPostEditor.13": "Article created successfully",
  "admin.content.AdminPostEditor.14": "Error updating article",
  "admin.content.AdminPostEditor.15": "Article updated successfully",
  "admin.content.AdminPostEditor.16": "Loading...",
  "admin.content.AdminPostEditor.17": "New article",
  "admin.content.AdminPostEditor.18": "Edit article",
  "admin.content.AdminPostEditor.19": "Back",
  "admin.content.AdminPostEditor.20": "New article",
  "admin.content.AdminPostEditor.21": "Edit article",
  "admin.content.AdminPostEditor.22": "Title *",
  "admin.content.AdminPostEditor.23": "Slug (URL) *",
  "admin.content.AdminPostEditor.24": "Used in the URL: /blog/",
  "admin.content.AdminPostEditor.25": "Author *",
  "admin.content.AdminPostEditor.26": "Publication date *",
  "admin.content.AdminPostEditor.27": "Future date = scheduled article, hidden until that date.",
  "admin.content.AdminPostEditor.28": "Cover image URL",
  "admin.content.AdminPostEditor.29": "Generating thumbnail…",
  "admin.content.AdminPostEditor.30": "✓ 480px thumbnail generated automatically.",
  "admin.content.AdminPostEditor.31": "Thumbnail not generated (image inaccessible due to CORS) — the full-size image will be used as a fallback.",
  "admin.content.AdminPostEditor.32": "A 480px WebP thumbnail will be generated automatically.",
  "admin.content.AdminPostEditor.33": "Summary",
  "admin.content.AdminPostEditor.34": "Short article description (optional)",
  "admin.content.AdminPostEditor.35": "Content * (HTML supported)",
  "admin.content.AdminPostEditor.36": "<p>Your content here...</p>",
  "admin.content.AdminPostEditor.37": "You can use HTML to format your content",
  "admin.content.AdminPostEditor.38": "Save",
  "admin.content.AdminPostEditor.39": "Cancel",
  "admin.content.AdminSettings.2": "Error loading settings",
  "admin.content.AdminSettings.3": "Shared drive enabled",
  "admin.content.AdminSettings.4": "Shared drive disabled",
  "admin.content.AdminSettings.5": "Error updating settings",
  "admin.content.AdminSettings.6": "Drive URL saved",
  "admin.content.AdminSettings.7": "Error saving settings",
  "admin.content.AdminSettings.8": "Password protection enabled",
  "admin.content.AdminSettings.9": "Password protection disabled",
  "admin.content.AdminSettings.11": "Error updating settings",
  "admin.content.AdminSettings.12": "Registration counter shown",
  "admin.content.AdminSettings.13": "Registration counter hidden",
  "admin.content.AdminSettings.15": "Error updating settings",
  "admin.content.AdminSettings.16": "Visitor visits enabled",
  "admin.content.AdminSettings.17": "Visitor visits disabled",
  "admin.content.AdminSettings.19": "Error updating settings",
  "admin.content.AdminSettings.20": "Maintenance mode enabled - visitors will see a maintenance page",
  "admin.content.AdminSettings.21": "Maintenance mode disabled - the site is accessible again",
  "admin.content.AdminSettings.23": "Error updating settings",
  "admin.content.AdminSettings.24": "Loading...",
  "admin.content.AdminSettings.25": "Site settings",
  "admin.content.AdminSettings.27": "Maintenance Mode",
  "admin.content.AdminSettings.28": "Enable maintenance mode to display a temporary page to visitors while you make changes",
  "admin.content.AdminSettings.29": "Enable maintenance mode",
  "admin.content.AdminSettings.30": "Visitors will see a maintenance page. Signed-in administrators can still access the site.",
  "admin.content.AdminSettings.31": "Maintenance mode is currently active. Visitors who are not signed in cannot access the site.",
  "admin.content.AdminSettings.32": "Security",
  "admin.content.AdminSettings.33": "Manage your site’s security settings",
  "admin.content.AdminSettings.34": "Password protection",
  "admin.content.AdminSettings.35": "When enabled, visitors must enter a password to access the site",
  "admin.content.AdminSettings.36": "Show registration counter",
  "admin.content.AdminSettings.37": "Displays the number of registered advisers on the home page",
  "admin.content.AdminSettings.38": "Enable visitor visits",
  "admin.content.AdminSettings.39": "Records visits in the admin \"Visitors\" section",
  "admin.content.AdminSettings.40": "Shared member drive",
  "admin.content.AdminSettings.41": "Set up a shared Google Drive folder accessible from the member area (page",
  "admin.content.AdminSettings.43": "). Members can view and upload files there.",
  "admin.content.AdminSettings.44": "Enable shared drive",
  "admin.content.AdminSettings.45": "When disabled, the page displays a “Coming soon” message to members.",
  "admin.content.AdminSettings.46": "Google Drive folder URL",
  "admin.content.AdminSettings.47": "Paste the shared folder URL (format",
  "admin.content.AdminSettings.49": "). The folder must be shared with “Anyone with the link” (viewer or editor).",
  "admin.content.AdminSettings.50": "Save",
  "admin.content.AdminSettings.51": "Current URL:",
  "admin.content.AdminSettings.53": "Sign out all members",
  "admin.content.AdminSettings.54": "Ends all active sessions. Each member will need to sign in again on their next visit. Your admin session is preserved.",
  "admin.content.AdminSettings.55": "Confirm signing out all members?",
  "admin.content.AdminSettings.56": "Admin session expired. Please sign in again.",
  "admin.content.AdminSettings.57": "Error signing out all members",
  "admin.content.AdminSettings.58": "Force sign-out for all members",
  "admin.content.suggestions.Resource": "Resource",
  "admin.content.suggestions.Bug": "Bug",
  "admin.content.suggestions.Other": "Other",
  "admin.content.suggestions.New": "New",
  "admin.content.suggestions.Member": "Member",
  "admin.content.scheduled": "📅 Scheduled article — automatically published on {date}.",
  "admin.content.signoutSuccess": "Forced sign-out sent ({count} member(s) targeted)",
  "admin.content.variant.info": "Info",
  "admin.content.variant.success": "Success",
  "admin.content.variant.warning": "Warning",
} as const;

export default contentEn;
